import {Component, Input, OnInit} from '@angular/core';
import {V3ExerciseSessionQuestion, V3Jumble, V3JumbleAnswerHolder} from "../../../../cspa/model/v3/cspa";

@Component({
    selector: 'app-jumble-result',
    templateUrl: './jumble-result.component.html',
    styleUrls: ['./jumble-result.component.scss'],
    standalone: false
})
export class JumbleResultComponent implements OnInit {
  @Input() questions: V3ExerciseSessionQuestion[] = []

  constructor() { }

  ngOnInit(): void {
  }

  getQuestion(q: V3ExerciseSessionQuestion) {
    const questionDef = q.questionDef as V3Jumble
    return questionDef.question.replace(/{\d}/g, "...")
  }

  getStudentAnswer(q: V3ExerciseSessionQuestion) {
    const answerHolder = q.questionDef?.answerDef?.answerHolder as V3JumbleAnswerHolder | null
    return answerHolder?.answer?.map(a => a.val.join("; ")) || "-"
  }

  getCorrectAnswer(q: V3ExerciseSessionQuestion) {
    const questionDef = q.questionDef as V3Jumble
    return questionDef.answerDef.answer.map(a => a.val.join(", ")).join("; ")
  }

  isAnswerIncorrect(q: V3ExerciseSessionQuestion) {
    const answerHolder = q.questionDef?.answerDef?.answerHolder as V3JumbleAnswerHolder | null
    return q.score == 0 && !!answerHolder
  }
}
